<template>
    <div class="preview">
        <headers :title='title'></headers>
        <template v-if="loading">
            <div class="content"
                 v-if="list.length">
                <h3 class="sum"
                    v-if="!type">共{{askLength}}题</h3>
                <div class="topic"
                     v-for="(topic,tindex) in list">
                    <!-- 一题多问的大题干 -->
                    <div class="title"
                         v-if="topic.asks.length">
                        <p v-html="topic.article_title"
                           v-if="topic.article_title"></p>
                        <p v-html="topic.article_text"
                           v-if="topic.article_text"></p>
                        <p v-html="topic.content"
                           v-if="topic.content"></p>
                    </div>
                    <!-- 一题多问的大题题干图片 -->
                    <template v-if="topic.asks.length&&topic.image">
                        <div class="cont_img"
                             v-for=" (img) in topic.image ">
                            <img :src="img"
                                 alt="" />
                        </div>
                    </template>
                    <div :class="{'ask':topic.asks.length&&askInd}"
                         v-for="(ask,askInd) in topic.asks">
                        <!-- 选择题 -->
                        <div v-if="ask.type===1||ask.type===3||ask.type===7||ask.type===8">
                            <choose-component :ask="ask"
                                              :type="ask.type"></choose-component>
                        </div>
                        <!-- 填空题 -->
                        <div v-if="ask.type === 2">
                            <fill-component :ask="ask"></fill-component>
                        </div>
                        <!-- 连线题 -->
                        <div v-if="ask.type === 4">
                            <line-component :ask="ask"
                                            :onlyshow="true"
                                            :sheet="ask.right_answer"></line-component>
                        </div>
                        <!-- 断句 -->
                        <div v-if="ask.type===6">
                            <sentence-component :ask="ask"></sentence-component>
                        </div>
                        <!-- 连词成句 -->
                        <div v-if="ask.type===5">
                            <make-component :ask="ask"
                                            :is_answer="true"
                                            :type="ask.type"></make-component>
                        </div>
                    </div>
                    <i class="is_issue"
                       v-if="type!=1&&topic.published_status"></i>
                    <div class="bottom">
                        <span v-if="!type">使用次数：{{topic.published_count}}次</span>
                        <span v-else>错误率：{{wrong_list[tindex].ratio}}%</span>
                    </div>
                </div>
            </div>
            <template v-else>
                <noResouse></noResouse>
            </template>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
import chooseComponent from 'VIEWS/chinese/module/result_choose.vue';   //选择题
import fillComponent from 'VIEWS/chinese/module/result_fill.vue';   //填空题
import lineComponent from 'VIEWS/chinese/module/result_line.vue';   //连线题
import makeComponent from 'VIEWS/chinese/module/result_make.vue';   //连词成句、连句成段题
import sentenceComponent from 'VIEWS/chinese/module/result_sentence.vue';   //断句题

export default {
    data () {
        return {
            type: this.$route.query.type,//1是高频错题
            paper_id: this.$route.params.paper_id,
            title: this.$route.query.title,
            wrong_list: JSON.parse(localStorage.getItem('wrong_list')),//高频错题
            loading: false,
            list: [],
            askLength: 0,//小题题量
            isHD_schoolopen: this.$route.query.schoolopen || 0,//开学大检查活动
        }
    },
    components: {
        headers, loadingS, noResouse, chooseComponent, fillComponent, lineComponent, makeComponent, sentenceComponent
    },
    methods: {},
    created () {
        if (this.type == 1) {
            localStorage.removeItem('wrong_list');
            this.$http.post(API_URL_TASK_API + '/chinese/make/paper/data', {
                qid: this.paper_id
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.list = res.data;
                    this.list.forEach(item => {
                        this.askLength += item.asks.length;
                    });
                    this.loading = true;
                }
            })
        } else {
            if (this.isHD_schoolopen == 1) {//开学大检查活动
                this.$http.post(API_URL_TASK_API + '/chinese/make/exercises_question_detail', {
                    qids: JSON.parse(localStorage.getItem('schoolopenQid'))
                }).then(res => {
                    if (res.data.response === 'ok') {
                        this.list = res.data.data;
                        this.list.forEach(item => {
                            this.askLength += item.asks.length;
                        });
                        this.loading = true;
                    }
                })
            } else {
                this.$http.post(API_URL_TASK_API + '/chinese/make/exercises_question', {
                    paper_id: this.paper_id
                }).then(res => {
                    res = res.data;
                    if (res.response === 'ok') {
                        this.list = res.data;
                        this.list.forEach(item => {
                            this.askLength += item.asks.length;
                        });
                        this.loading = true;
                    }
                })
            }
        }
    },
    beforeDestroy () {
        localStorage.removeItem('schoolopenQid')
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.ask {
    border-top: 1px / $ppr solid #e8e8e8;
}

.preview {
    min-height: 100vh;
    box-sizing: border-box;
    .header-wrap {
        .header {
            background: #5e89ef;
        }
        .left {
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/white_back.png") no-repeat;
            background-size: 100% 100%;
        }
    }
    .sum {
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 30px / $ppr;
        font-weight: bold;
        color: #333;
        background: #fff;
    }
    .content {
        margin-bottom: 24px / $ppr;
        font-size: 30px / $ppr;
        color: #333;
        .topic {
            position: relative;
            margin-top: 24px / $ppr;
            background: #fff;
            .title {
                p {
                    padding: 34px / $ppr 24px / $ppr;
                    border-top: 1px / $ppr solid #e8e8e8;
                    &:first-child {
                        border-top: none;
                    }
                }
            }
            .bottom {
                padding: 0 24px / $ppr;
                height: 96px / $ppr;
                line-height: 96px / $ppr;
                font-size: 24px / $ppr;
                color: #999;
                border-top: 1px / $ppr solid #e8e8e8;
            }
            .is_issue {
                position: absolute;
                top: 24px / $ppr;
                right: 0;
                display: block;
                width: 100px / $ppr;
                height: 56px / $ppr;
                background: url("./img/icon_issue.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
}
</style>
